module.exports = __webpack_public_path__ + "img/tick-square.679db9f5.svg";